import type OnDemandServicesSettings from 'owa-service/lib/contract/OnDemandServicesSettings';
import type { BookingOnDemandServicesSettings } from 'owa-graph-schema';
import type BookingOnDemandServicesSettingsEnum from '../../constants/bookingOnDemandServicesSettingsEnum';

const mapOnDemandServicesSetting = (
    onDemandServicesSettings: OnDemandServicesSettings | undefined
): BookingOnDemandServicesSettings | undefined => {
    if (onDemandServicesSettings === undefined) {
        return;
    }

    switch (onDemandServicesSettings) {
        case 1:
            return 'Created';
        case 2:
            return 'Enabled';
        default:
            return 'Empty';
    }
};

export default mapOnDemandServicesSetting;
